(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aditi-bundle-builder"]) return;
  try {
    
  document.querySelectorAll('[data-aditi-bundle]').forEach((builder) => {
    const form = builder.querySelector('form');
    const sizeInputs = [...builder.querySelectorAll('[name="aditi-bundle-size"]')];
    const cards = [...builder.querySelectorAll('[data-scent-card]')];
    const picks = new Map();
    const button = builder.querySelector('[data-bundle-submit]');
    const selectedSize = () => sizeInputs.find((input) => input.checked);
    const picked = () => [...picks.values()].reduce((sum, qty) => sum + qty, 0);
    const render = () => {
      const size = selectedSize();
      if (!size) return;
      const target = Number(size.dataset.count);
      const total = picked();
      builder.querySelector('[data-bundle-progress]').textContent = `${total} of ${target} selected`;
      builder.querySelector('[data-bundle-meter]').style.width = `${Math.min(total / target, 1) * 100}%`;
      builder.querySelector('[data-bundle-variant]').value = size.value;
      const list = builder.querySelector('[data-bundle-summary]');
      list.replaceChildren();
      const properties = builder.querySelector('[data-bundle-properties]');
      properties.replaceChildren();
      cards.forEach((card) => {
        const qty = picks.get(card.dataset.scentId) || 0;
        const output = card.querySelector('[data-scent-count]');
        if (output) output.textContent = qty;
        const minus = card.querySelector('[data-scent-minus]');
        const plus = card.querySelector('[data-scent-plus]');
        if (minus) minus.disabled = qty === 0;
        if (plus) plus.disabled = total >= target;
        if (qty > 0) {
          const li = document.createElement('li');
          li.textContent = `${card.dataset.scentName} × ${qty}`;
          list.append(li);
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${card.dataset.scentName}]`;
          input.value = String(qty);
          properties.append(input);
        }
      });
      if (!list.children.length) {
        const li = document.createElement('li');
        li.textContent = 'Choose your scents below.';
        list.append(li);
      }
      button.disabled = total !== target;
      button.textContent = total === target ? `Add bundle to cart · ${size.dataset.price}` : total > target ? `Remove ${total - target} candle${total - target === 1 ? '' : 's'}` : `Choose ${target - total} more`;
    };
    builder.addEventListener('click', (event) => {
      const plus = event.target.closest('[data-scent-plus]');
      const minus = event.target.closest('[data-scent-minus]');
      if (!plus && !minus) return;
      const card = event.target.closest('[data-scent-card]');
      const id = card.dataset.scentId;
      const current = picks.get(id) || 0;
      if (plus && picked() < Number(selectedSize().dataset.count)) picks.set(id, current + 1);
      if (minus && current > 0) {
        if (current === 1) picks.delete(id);
        else picks.set(id, current - 1);
      }
      render();
    });
    sizeInputs.forEach((input) => input.addEventListener('change', render));
    form.addEventListener('submit', (event) => {
      if (picked() !== Number(selectedSize().dataset.count)) event.preventDefault();
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aditi-review-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aditi-review-strip')) {
    customElements.define('aditi-review-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.reviews = Array.from(this.querySelectorAll('[data-review]'));
        this.currentIndex = 0;
        const options = { signal: this.controller.signal };
        const previous = this.querySelector('[data-review-previous]');
        const next = this.querySelector('[data-review-next]');
        if (this.reviews.length > 1) {
          previous.hidden = false;
          next.hidden = false;
          previous.addEventListener('click', () => this.showReview(this.currentIndex - 1), options);
          next.addEventListener('click', () => this.showReview(this.currentIndex + 1), options);
        }
        this.addEventListener('shopify:block:select', event => {
          const index = this.reviews.findIndex(review => review.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.showReview(index);
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      showReview(index) {
        this.currentIndex = (index + this.reviews.length) % this.reviews.length;
        this.reviews.forEach((review, position) => {
          const active = position === this.currentIndex;
          review.classList.toggle('is-current', active);
          review.setAttribute('aria-hidden', String(!active));
          review.inert = !active;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-reader"]) return;
  try {
    

(() => {
  const initialize = () => {
    document.querySelectorAll('.ym-reading').forEach(reader => {
      if (reader.dataset.ymReady) return;
      reader.dataset.ymReady = 'true';
      const navigation = reader.querySelector('.ym-index-scroll');
      const active = navigation?.querySelector('[aria-current="page"]');
      if (navigation && active) navigation.scrollTop = Math.max(0, active.offsetTop - navigation.offsetTop - 72);
      const menu = reader.querySelector('.ym-mobile-contents');
      const guide = reader.querySelector('.ym-pinned-guide');
      guide?.addEventListener('keydown', event => {
        if (event.key === 'Escape' && guide.open) { guide.open = false; guide.querySelector('summary').focus(); }
      });
      guide?.addEventListener('toggle', () => { if (guide.open && menu) menu.open = false; });
      menu?.addEventListener('toggle', () => { if (menu.open && guide) guide.open = false; });
      document.addEventListener('click', event => { if (guide?.open && !guide.contains(event.target)) guide.open = false; });
      menu?.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu?.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      const tools = reader.querySelector('.ym-text-tools');
      if (!tools) return;
      const smaller = tools.querySelector('[data-ym-size="smaller"]');
      const larger = tools.querySelector('[data-ym-size="larger"]');
      const status = tools.querySelector('[data-ym-size-status]');
      const sizes = [14, 16, 18, 20];
      let size = 16;
      try { const saved = Number(localStorage.getItem('aditi-ym-text-size-v2')); if (sizes.includes(saved)) size = saved; } catch {}
      const update = announce => {
        reader.style.setProperty('--ym-reading-size', `${size}px`);
        smaller.disabled = size === sizes[0];
        larger.disabled = size === sizes[sizes.length - 1];
        if (announce) status.textContent = `${status.dataset.sizeLabel}: ${size}px`;
      };
      tools.hidden = false;
      tools.addEventListener('click', event => {
        const button = event.target.closest('[data-ym-size]');
        if (!button || button.disabled) return;
        size = sizes[sizes.indexOf(size) + (button.dataset.ymSize === 'larger' ? 1 : -1)];
        update(true);
        try { localStorage.setItem('aditi-ym-text-size-v2', String(size)); } catch {}
      });
      update(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
